var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationIconFtueVideos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "24px-ftue-videos-01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.49,3.13a1,1,0,0,0-1,0L18,5.23V3a1,1,0,0,0-1-1H7A1,1,0,0,0,6,3V8a.5.5,0,0,0,0,.13A4,4,0,0,0,4.38,15H2a1,1,0,0,0-1,1v5.38a1,1,0,0,0,.77,1A22.74,22.74,0,0,0,7,23a22.74,22.74,0,0,0,5.23-.65,1,1,0,0,0,.77-1V16a1,1,0,0,0-1-1H9.62a4.05,4.05,0,0,0,1.24-2H17a1,1,0,0,0,1-1V9.77l3.49,2.09A1,1,0,0,0,22,12a1,1,0,0,0,.49-.13A1,1,0,0,0,23,11V4A1,1,0,0,0,22.49,3.13ZM11,20.58a19.26,19.26,0,0,1-8,0V17h8ZM7,10a2,2,0,1,1-2,2A2,2,0,0,1,7,10Zm9,1H10.86A4,4,0,0,0,8,8.13.5.5,0,0,0,8,8V4h8Zm5-1.77L18.11,7.5,21,5.77Z",
    fill: "#343434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationIconFtueVideos);
export default __webpack_public_path__ + "static/media/navigation-icon-ftue-videos.fd98869b2ecae800f17a235a9c8733b6.svg";
export { ForwardRef as ReactComponent };